
function Loading(props: {text?: string}) {
  return (<div className="grid place-items-center h-screen heading"><p className="text-2xl">{ props.text ?? "Laden..."}</p></div>);
}

export default Loading;
